import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["location"];

  toggleLocation(event) {
    const isChecked = event.target.checked;

    if (isChecked) {
      this.locationTarget.classList.remove("hidden");
    } else {
      this.locationTarget.classList.add("hidden");
      this.clearLocationFields();
    }
  }

  clearLocationFields() {
    console.log("clearLocationFields called");

    // Clear all input and textarea fields within the location section
    const inputs = this.locationTarget.querySelectorAll(
      'input:not([type="checkbox"]), textarea',
    );
    inputs.forEach((input) => {
      console.log(
        "Clearing field:",
        input.name ||
          input.getAttribute("data-country-search-target") ||
          input.getAttribute("data-subdivision-search-target"),
      );
      input.value = "";
    });
  }
}

// Global function for appointment policy radio buttons
window.handleAppointmentPolicy = function (element, required, recommended) {
  const form = element.closest("form");
  const requiredField = form.querySelector(
    'input[name="venue_form[appointment_required]"]',
  );
  const recommendedField = form.querySelector(
    'input[name="venue_form[appointment_recommended]"]',
  );

  if (requiredField) {
    requiredField.value = required;
  }
  if (recommendedField) {
    recommendedField.value = recommended;
  }
};
